import React, { useState, useEffect } from 'react';
import { ReactComponent as DropDown } from '../../assets/icons/drop-down.svg';
import { ReactComponent as DropRight } from '../../assets/icons/drop-right.svg';
import Brokoli from '../../assets/images/brokoli.png';
import PopupAddingProduct from '../../components/Merchandise/PopupAddingProduct';

import JagungManis from '../../assets/images/sayur/buah/jagung.jpeg';
import Wortel from '../../assets/images/sayur/akar/wortel.jpeg';
import Daging from '../../assets/images/daging/sapi.jpeg';
import Kentank from '../../assets/images/sayur/umbi/kentang.jpeg';
import Sawi from '../../assets/images/sayur/daun/sawi.jpeg';
// import listProduct from '../../data/items.json';
const MenuProduct = ({
  listProduct = [
    {
      name: 'brokoli',
      weight: '251g',
      category: 'sayurDaun',
      img: Brokoli,
      price: '30.000',
    },
    {
      name: 'jagun manis',
      weight: '251g',
      category: 'sayurBayam',
      img: JagungManis,
      price: '30.000',
    },
    {
      name: 'wortel',
      weight: '251g',
      category: 'sayurBayang',
      img: Wortel,
      price: '30.000',
    },
    {
      name: 'kentang',
      weight: '251g',
      category: 'sayurUmbi',
      img: Kentank,
      price: '30.000',
    },
    {
      name: 'sawi',
      weight: '251g',
      category: 'sayurDaun',
      img: Sawi,
      price: '30.000',
    },
    {
      name: 'sawi',
      weight: '251g',
      category: 'sayurBayam',
      img: Sawi,
      price: '30.00 0',
    },
    {
      name: 'Daging Sapi',
      weight: '251g',
      category: 'sapi',
      img: Daging,
      price: '30.000',
    },
    {
      name: 'Sayap Ayam',
      weight: '251g',
      category: 'ayam',
      img: Daging,
      price: '30.000',
    },
  ],
}) => {
  const [showTab, setShowTab] = useState(0);
  const [products, setProducts] = useState(listProduct);
  const [category, setCategory] = useState('all');
  const [addProductPopup, setAddProductPopup] = useState(false);

  function handleShowPopupProduct() {
    setAddProductPopup(!addProductPopup);
  }
  useEffect(() => {
    let filteredProducts = listProduct;
    if (category !== 'all') {
      filteredProducts = filteredProducts.filter(
        (product) => product.category === category
      );
    }
    setProducts(filteredProducts);
  }, [category]);
  return (
    <div className="flex h-full items-start">
      {addProductPopup ? (
        <PopupAddingProduct handdleClick={handleShowPopupProduct} />
      ) : null}
      <div className="bg-white h-full w-3/12">
        <div className="h-full px-8 py-6 ">
          <h4 className="text-xl font-semibold">Kategori Produk</h4>
          <button
            className="flex items-center mt-4 w-full"
            onClick={() => setShowTab(1)}
          >
            {showTab === 1 ? (
              <DropDown className="h-8 w-8" alt="Icon" />
            ) : (
              <DropRight className="h-6 w-6 m-1" alt="Icon" />
            )}
            <p className="tracking-0-4">Sayuran</p>
          </button>
          <div
            className={
              ' flex-col ml-12 items-start' +
              (showTab === 1 ? ' flex ' : ' hidden')
            }
          >
            <button
              className="tracking-0-4 my-1 hover:text-basic-orange"
              onClick={() => setCategory('sayurDaun')}
            >
              Sayur Daun
            </button>
            <button
              className="tracking-0-4 my-1 hover:text-basic-orange"
              onClick={() => setCategory('sayurBayam')}
            >
              Sayur Bayem
            </button>
            <button
              className="tracking-0-4 my-1 hover:text-basic-orange"
              onClick={() => setCategory('sayurBawang')}
            >
              Sayur Bawang
            </button>
          </div>
          <button
            className="flex items-center mt-4 w-full"
            onClick={() => setShowTab(2)}
          >
            {showTab === 2 ? (
              <DropDown className="h-8 w-8" alt="Icon" />
            ) : (
              <DropRight className="h-6 w-6 m-1" alt="Icon" />
            )}
            <p className="tracking-0-4">Buah</p>
          </button>
          <div
            className={
              ' flex-col ml-12 items-start' +
              (showTab === 2 ? ' flex ' : ' hidden')
            }
          >
            <button
              className="tracking-0-4 my-1 hover:text-basic-orange"
              onClick={() => setCategory('buahDaun')}
            >
              Buah Daun
            </button>
            <button
              className="tracking-0-4 my-1 hover:text-basic-orange"
              onClick={() => setCategory('buahBayem')}
            >
              Buah Bayem
            </button>
            <button className="tracking-0-4 my-1 hover:text-basic-orange">
              Buah Bawang
            </button>
          </div>
          <button
            className="flex items-center mt-4 w-full"
            onClick={() => setShowTab(3)}
          >
            {showTab === 3 ? (
              <DropDown className="h-8 w-8" alt="Icon" />
            ) : (
              <DropRight className="h-6 w-6 m-1" alt="Icon" />
            )}
            <p className="tracking-0-4">Nasi</p>
          </button>
          <div
            className={
              ' flex-col ml-12 items-start' +
              (showTab === 3 ? ' flex ' : ' hidden')
            }
          >
            <button className="tracking-0-4 my-1 hover:text-basic-orange">
              Nasi Daun
            </button>
            <button className="tracking-0-4 my-1 hover:text-basic-orange">
              Nasi Bayem
            </button>
            <button className="tracking-0-4 my-1 hover:text-basic-orange">
              Nasi Bawang
            </button>
          </div>
          <button
            className="flex items-center mt-4 w-full"
            onClick={() => setShowTab(4)}
          >
            {showTab === 4 ? (
              <DropDown className="h-8 w-8" alt="Icon" />
            ) : (
              <DropRight className="h-6 w-6 m-1" alt="Icon" />
            )}
            <p className="tracking-0-4">Alat</p>
          </button>
          <div
            className={
              ' flex-col ml-12 items-start' +
              (showTab === 4 ? ' flex ' : ' hidden')
            }
          >
            <button className="tracking-0-4 my-1 hover:text-basic-orange">
              Alat Daun
            </button>
            <button className="tracking-0-4 my-1 hover:text-basic-orange">
              Alat Bayem
            </button>
            <button className="tracking-0-4 my-1 hover:text-basic-orange">
              Alat Bawang
            </button>
          </div>
          <button
            className="flex items-center mt-4 w-full"
            onClick={() => setShowTab(5)}
          >
            {showTab === 5 ? (
              <DropDown className="h-8 w-8" alt="Icon" />
            ) : (
              <DropRight className="h-6 w-6 m-1" alt="Icon" />
            )}
            <p className="tracking-0-4">Daging</p>
          </button>
          <div
            className={
              ' flex-col ml-12 items-start' +
              (showTab === 5 ? ' flex ' : ' hidden')
            }
          >
            <button
              className="tracking-0-4 my-1 hover:text-basic-orange"
              onClick={() => setCategory('sapi')}
            >
              Sapi{' '}
            </button>
            <button
              className="tracking-0-4 my-1 hover:text-basic-orange"
              onClick={() => setCategory('ayam')}
            >
              Ayam
            </button>
          </div>
        </div>
      </div>
      <div className="pl-6  w-9/12 flex flex-wrap items-start justify-start">
        {products.length > 0 ? (
          products.map((items, index) => (
            <div className="w-3/12 px-4 mb-6" key={index}>
              <div className="bg-white pt-3 pb-8 px-6 flex flex-col">
                <div
                  onClick={() => {
                    setAddProductPopup(!addProductPopup);
                  }}
                >
                  <img
                    className="h-auto w-full"
                    src={items.img}
                    alt={items.name}
                  />
                </div>
                <p className="font-semibold text-lg uppercase">{items.name}</p>
                <p className="text-sm">{items.weight}</p>
                <p className="text-lg font-semibold text-font-gray">
                  Rp {items.price}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="w-full flex items-center justify-center h-64 uppercase text-lg text-font-gray">
            {' '}
            Tidak Ada Product{' '}
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuProduct;
